import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import HomeBanner from './HomeBanner';
import HomeCategory from './HomeCategory';
import HomeManager from './HomeManager';
import HomeStores from './HomeStores';
import AppHeader2 from './AppHeader2';
import BottomMenu from './BottomMenu';
import SidebarPanel from './SidebarPanel';

class Categories extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            LOCATION: this.props.location.pathname,
            LOADING: true, 
            categories: [],
            CUSTOMER_DET: ''
        };
    }

    fetchCategoryPage(mode) {

        var id = localStorage.getItem('delCIRCLE');

        let customer = '';
        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');
        
        var that = this;
        fetch('https://m.donedelivery.in/api/categories_api.php?mode='+mode+'&id='+id+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            var CATEGORIES = result.CATEGORIES;
            var CUSTOMER_DET = 'Hi User';
            if(result.CUSTOMER!=='' && result.CUSTOMER!==undefined && result.CUSTOMER!=='undefined')
                CUSTOMER_DET = result.CUSTOMER;
            
            that.setState({ LOADING:false, categories:CATEGORIES, CUSTOMER_DET:CUSTOMER_DET });
        });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        this.fetchCategoryPage('CATEGORY');
    }

    render() { 
        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Categories';
        let AppHeaderRight = '';
        let AppHeaderRightLink = 'SEARCH';
        let AppHeaderSearch = '';

        let categories = this.state.categories.map((post, i)=>{

            let OfferType = '';
            let OfferType2 = '';
            if(post.OFFER_TYPE!=='')
            {
                if(post.OFFER_TYPE=='PER') OfferType = '%';
                if(post.OFFER_TYPE=='DIS') OfferType = '&#8377;';
            }

            return (
                <div className="col-6" key={post.ID}>
                    <Link to={`/category/${post.ID}`}>
                        <div className="card mb-2">
                            {post.OFFER!='' && <div className="chip off-tags chip-warning"><span className="chip-label">{OfferType2}{post.OFFER}{OfferType} Off</span></div>}
                            <div className="categoriesHeight">
                                <img src={post.IMAGE} className="card-img-top" alt={post.NAME} />
                            </div>
                            <div className="card-body pt-07 pb-07 text-center categoriesText">
                            <p className="card-text font-size-13 text-dgrey font-weg-500">{post.NAME}</p>
                            </div>
                        </div>
                    </Link>
                </div>
            );
        });

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch} />
                <div id="appCapsule">
                    <div className="section pt-2 pb-2">
                        <div className="row">
                            {categories}
                        </div>
                    </div>
                </div>
                <BottomMenu LOCATION={this.state.LOCATION} />
                {this.state.CUSTOMER_DET && <SidebarPanel CUSTOMER_DET={this.state.CUSTOMER_DET}/>}
            </div>
        );
    }
}
      
export default Categories;


// WEBPACK FOOTER //
// ./src/components/Categories.js